module.exports = __webpack_public_path__ + "static/media/pos-onboarding.c8b891c5.png";